import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import SearchFilterToggle from './SearchFilterToggle';
import onHasAttachmentsFilterClicked from '../utils/onHasAttachmentsFilterClicked';
import onIsUnreadFilterClicked from '../utils/onIsUnreadFilterClicked';
import { observer } from 'mobx-react-lite';
import { getStore } from '../store/store';
import loc from 'owa-localize';
import { searchFilterLabel_hasAttachment } from 'owa-locstrings/lib/strings/searchFilterLabel.locstring.json';
import { unreadFilter } from 'owa-locstrings/lib/strings/unreadfilter.locstring.json';
import TimeSearchFilter from './TimeSearchFilter';
import getSearchQueryHasAttachmentsKqlMatches from '../utils/getSearchQueryHasAttachmentsKqlMatches';
import { getScenarioStore, SearchScenarioId } from 'owa-search';
import { useComputedValue } from 'owa-react-hooks/lib/useComputed';

export default observer(function SearchFiltersContainer(): JSX.Element {
    const mailSearchStore = getStore();

    const hasAttachmentsKqlMatch = useComputedValue(() => {
        const { searchText: searchBoxText } = getScenarioStore(SearchScenarioId.Mail);
        const matches = getSearchQueryHasAttachmentsKqlMatches(searchBoxText);
        let hasMatch = false;
        if (matches?.length > 0) {
            // Use last value if user has typed multiple kql values
            const value = matches.pop().substring(15 /* hasattachments: */).toLocaleLowerCase();
            hasMatch = value === 'yes' || value === 'true';
        }
        return hasMatch;
    });
    return (
        <>
            <SearchFilterToggle
                label={loc(searchFilterLabel_hasAttachment)}
                isSelected={hasAttachmentsKqlMatch || mailSearchStore.includeAttachments}
                onClick={onHasAttachmentsFilterClicked}
                icon={ControlIcons.Attach}
            />
            <SearchFilterToggle
                label={loc(unreadFilter)}
                isSelected={mailSearchStore.isUnread}
                onClick={onIsUnreadFilterClicked}
                icon={ControlIcons.Mail}
            />
            <TimeSearchFilter />
        </>
    );
});
